// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2b7d812a]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.add-block-left[data-v-2b7d812a]{cursor:pointer;line-height:32px;vertical-align:middle}.add-block-content .add-circle[data-v-2b7d812a],.add-block-content:hover .add-circle[data-v-2b7d812a]{border:1px solid #3d46f5;color:#3d46f5}.add-block-content:hover:hover .add-circle[data-v-2b7d812a]{background-color:#3d46f5;color:#273261}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
